// Форматирование для кабинета поставщика. Деньги приходят в копейках.

export const rub = (kop: number): string =>
  (kop / 100).toLocaleString('ru-RU', { maximumFractionDigits: 0 }) + ' ₽';

export const dateShort = (iso: string): string =>
  new Date(iso).toLocaleDateString('ru-RU', { day: '2-digit', month: 'short' });

export const dateTime = (iso: string): string =>
  new Date(iso).toLocaleString('ru-RU', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });

/** С секундами — для журнала обмена, где важен точный порядок запросов. */
export const dateTimeExact = (iso: string): string =>
  new Date(iso).toLocaleString('ru-RU', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
